export class AppConfig {
    public static KEY_TIPO_DOCUMENTO(): string { return 'customer_tipo_documento'; }
    public static TOKEN_NAME_JTWT(): string { return 'jw_token' }
    public static SSO_TOKEN(): string { return 'sso_token' }
    public static SSO_CIAM(): string { return 'sso_persona' }
    public static get VALIDITY_TOKEN_MICROSERVICES(): number { return 604800;  }
    public static KEY_TIMES_MICROSERVICES(): string { return  'key_time_microservices'; }
    // Vulnerabilidad: Referencia de entorno local en archivo público (2.7 Baja) — DEVELOP_ENDPOINT (localhost) y credenciales de prueba sin uso, retirados por quedar expuestos en el bundle público
    public static get KEY_RATE_NOTIFICATION(): string {return 'key_ratenotification';}
    public static get KEY_TYPE_RESERVATION(): string {return 'key_reservation';}
  }
